import React from "react";
// import Pagination from "@mui/material/Pagination";
// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
import {
  Pagination,
  Select,
  MenuItem,
  Typography,
  Box,
  SvgIcon,
  Avatar,
  FormControl,
  Button,
  TextField,
  InputAdornment,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ColvisButton from "@/pages/payroll/component/table/colvisButton";
import {
  Search as SearchIcon,
  ArrowDropDown as ArrowDropDownIcon,
} from "@mui/icons-material";
import Export from "@/components/dataTableComponents/Export";
import Csv from "@/components/dataTableComponents/Csv";
const TableSearch = ({
  headers,
  handleToggleColumn,
  colvis,
  searchBar,
  visibleColumns,
  colvisColumns,
  exportOption,
  csvOption,
  searchQuery,
  setSearchQuery
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={1}
      sx={{
        // mt: colvis || searchBar ||exportOption ||csvOption ? 3 : 0,
        mb: colvis || searchBar ||exportOption ||csvOption? 3 : 0,
      }}
    >
      {colvis && (
        <ColvisButton
          headers={headers}
          handleToggleColumn={handleToggleColumn}
          visibleColumns={visibleColumns}
          colvisColumns={colvisColumns}
        />
      )}
      {exportOption && (<Export name="Export"/>)}
      {csvOption && (<Csv/>)}

      <Box sx={{ flexGrow: 1 }} />

      {searchBar && (
        <TextField
          size="small"
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="end" sx={{marginRight:"3px"}}>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
           value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={(theme)=>({
            width: "100%",
            maxWidth: "250px",
            borderRadius:"32px",
            color:"#FAFAFA",
            backgroundColor:"#FAFAFA",
            border:`1px solid ${theme.palette.BudgieThemeColor.Neutrals[300]}`,
            "& .MuiOutlinedInput-root": {
              padding: "0px",
              height: "35px",
              borderRadius:"32px",
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.BudgieThemeColor.Neutrals[100],
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.BudgieThemeColor.Neutrals[100],
            },
          })}
        />
      )}
    </Stack>
  );
};

export default TableSearch;
